<template>
  <section id="hero" class="hero">
    <div
      class="hero__container"
      :style="{
        backgroundImage: `url(${backgroundImage})`,
      }"
    >
      <div class="hero__section">
        <div class="hero__content">
          <div id="hero-main" v-track-visibility.once class="hero__text">
            <h1 class="hero__headline">
              Op zoek naar de<br />
              <span class="hero__highlight">juiste makelaar</span>? <br />Wij
              helpen je!
            </h1>
            <p class="hero__subheadline">
              Kom direct in contact met makelaars in
              <br class="hidden lg:block" />
              jouw regio die perfect bij jou passen
            </p>
          </div>

          <div id="hero-visuals" v-track-visibility.once class="hero__visuals">
            <div class="hero__visuals-container-card lg:w-3/4 md:w-auto mb-3">
              <div class="hero__desktop-visual-container md:mt-2">
                <div class="hero__desktop-visual">
                  <!-- postal form input -->
                  <TCard class="header__card">
                    <div class="card__form">
                      <PostalFormStepPd8337 :progress-value="0" />
                    </div>
                  </TCard>
                </div>
              </div>
              <div class="hero__usps-container">
                <div class="hero__usps">
                  <div class="hero__usp-item hero__usp-item-pd-8337">
                    <span class="hero__usp-text">Gratis & vrijblijvend!</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <svg
          width="400"
          height="120"
          viewBox="0 0 400 120"
          class="hero__shape"
          preserveAspectRatio="none"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0 L200 117.5 L400 0 V120 H0 V0 Z" fill="white" />
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
import PostalFormStepPd8337 from './form/steps/postal/PostalFormStep.PD-8337.vue'

export default {
  name: 'HeroComponent',

  components: {
    PostalFormStepPd8337,
  },

  props: {
    enterFormPath: {
      type: String,
      default: '/offertes-aanvragen/start',
    },

    backgroundImage: {
      type: String,
      default: 'images/hero.jpg',
    },

    usps: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.hero {
  @apply relative w-full text-white overflow-hidden bg-cover bg-center;

  &__container {
    @apply bg-cover bg-center bg-no-repeat;
  }

  &__section {
    @apply relative flex flex-col justify-between pt-16 backdrop-grayscale bg-black/50 bg-blend-darken md:justify-center;
  }

  &__content {
    @apply container z-10 py-10 flex flex-col w-full md:flex-row md:items-center md:justify-between md:px-8 md:pb-8;
  }

  &__text {
    @apply flex flex-col items-center text-center;
    @apply md:items-start md:text-left md:w-1/2 md:pr-8;
  }

  &__headline {
    @apply text-4xl lg:text-6xl leading-10 font-bold mb-6 lg:mb-10;
  }

  &__highlight {
    @apply text-[#FF3D00];
  }

  &__subheadline {
    @apply mb-16 px-4 opacity-90 order-3 md:order-2 md:px-0 text-lg lg:text-2xl md:mb-6;
  }

  &__cta-button {
    background: linear-gradient(167deg, #ee3b13 47.92%, #c1062b 126.29%);
    @apply mb-10 mt-6 md:my-0 border-0 font-bold px-10 py-3 rounded-lg order-2;

    &:hover {
      background-color: #c53030;
    }
  }

  &__visuals {
    @apply flex md:flex-col items-center justify-center md:w-1/2 md:pl-8;
  }

  &__visuals-container-card {
    @apply flex flex-col items-center justify-center md:w-1/2 rounded-xl pb-3;
    background: white;
  }

  &__desktop-visual-container {
    @apply relative justify-center;
  }

  &__desktop-visual {
    @apply w-full max-w-md h-auto text-center;
  }

  &__usps-container {
    @apply flex justify-center;
  }

  &__usps {
    @apply flex w-full;
  }

  &__usp-item {
    @apply flex gap-3 items-center text-center mx-2 flex-1;
    &-pd-8337 {
      @apply pb-3;
      color: #3e3e3e;
    }
  }

  &__usp-icon {
    @apply w-6 h-6 flex items-center justify-center text-xs;

    & > svg {
      @apply w-full h-full;
    }
  }

  &__usp-text {
    @apply text-sm font-medium leading-none;
  }

  &__shape {
    @apply h-15 md:h-28 w-full -mb-[1px];
  }
}

.t-card.header__card {
  @apply rounded-xl;
}
</style>
